export default __webpack_public_path__ + "static/media/Rule12.8dc7a3db.png";